import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { Branch } from "../branch.model";
import { OrganisationProfile } from "../organisation/organisation-profile";
import { Organisation } from "../organisation/organisation.model";
import { UserProfile} from "./user-profile.model";

export class User{
  constructor(
    public id:string,
    public profileId:string = "",
    public createdAt?: Date,
    public firstName:string = "",
    public lastName:string = "",
    public email:string = "",
    public communicationEmail:string = "",
    public language:string = 'nl',
    public image:string = "",
    public profiles:UserProfile[] = [],
    public gender:string = "",
    public dateOfBirth:Date|null = null,
    public referral:string = "",
    public referralUserId:string = "",
    public referralUsed:boolean = false,
    public referralDenied:boolean = false,
    public emailMfaEnabled:boolean = false,
    public icalUrl:string = '',
    // The user's previous login (before the current session); null on a first-ever login.
    public lastLogin:Date|null = null
  ){}

  public getName(){
    return this.lastName + ' ' + this.firstName;
  }

  getBranches(sortOnActive:boolean = true):Array<{profile:UserProfile,branch:Branch}>{
    let branches:Array<{profile:UserProfile,branch:Branch}> = [];
    this.profiles.forEach(profile =>{
      let profilebranches = profile.client.branches.map(x => {return {profile: profile, branch:x}});
      branches = [...profilebranches,...branches];
    });

    branches.sort((a,b) => a.branch.name.localeCompare(b.branch.name));
    if(sortOnActive){
      branches.sort((a,b) => Number(b.branch.active) - Number(a.branch.active));
    }

    return branches;
  }

  getBranchesForOrganisation(organisation:Organisation):Array<{profile:OrganisationProfile,branch:Branch}>{
    let branches:Array<{profile:OrganisationProfile,branch:Branch}> = [];
    this.profiles.forEach(profile =>{
      let profilebranches = profile.client.branches.map(x => {
        let nbranch = x;
        nbranch.active = false;
        nbranch.connected = false;
        return {profile: new OrganisationProfile('',organisation.name,[],profile.client,[]), branch:nbranch}});
      branches = [...profilebranches,...branches];
    });

    branches.sort((a,b) => a.branch.name.localeCompare(b.branch.name));

    return branches;
  }
}


@Injectable({
  providedIn: 'root'
})

export class UserAdapter implements Adapter<User> {
  constructor() {}

  adapt(item: any): User {
    return new User(
      item.user.id,
      item.profile.id,
      item.user.createdAt,
      item.profile.firstName,
      item.profile.lastName,
      item.profile.emailAddress.toLowerCase(),
      (item.profile.communicationEmailAddress || '').toLowerCase(),
      item.profile.language.split('/').pop(),
      '',
      [],
      item.profile.gender,
      item.profile.dateOfBirth ? new Date(item.profile.dateOfBirth):null,
      (item.user.unclaimedReferral? item.user.unclaimedReferral.referral :'').split('/').pop(),
      (item.user.unclaimedReferral? item.user.unclaimedReferral.id :''),
      (item.user.amountOfUnclaimedReferrals??0) == 0,
      item.user.declinedAt ?? false,
      item.user.emailAuthEnabled ?? false,
      item.user.icalUrl??'',
      item.user.lastLoginFromSecurityLogs ? new Date(item.user.lastLoginFromSecurityLogs) : null
    );
  }
}
